module.exports = __webpack_public_path__ + "static/moje_sarajevo-b67a59d7fb80f753ba4648b4defa91a5.png";